import { render } from "./IncludedContentItem.vue?vue&type=template&id=7ffca1be&scoped=true"
import script from "./IncludedContentItem.vue?vue&type=script&lang=js"
export * from "./IncludedContentItem.vue?vue&type=script&lang=js"

import "./IncludedContentItem.vue?vue&type=style&index=0&id=7ffca1be&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ffca1be"]])

export default __exports__